import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  TextField, Button, Card, CardContent, Typography, CircularProgress, IconButton, Avatar
} from '@mui/material';
import { Box } from '@mui/system';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import apiInstance from '../../services/ServiceApi';
import logo from '../../assets/logo.png';
function useMobileDetect() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile;
}

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const isMobile = useMobileDetect();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      const response = await apiInstance.post('/login', {
        username,
        password,
      });

      localStorage.setItem('token', JSON.stringify(response.data.token));
      localStorage.setItem('user', JSON.stringify(response.data.user));
      localStorage.setItem('permissions', JSON.stringify(response.data.permissions));
      window.location.href="./"
      //navigate('/');
    } catch (error) {
      console.error('Hubo un error al iniciar sesión:', error);
    } finally {
      setIsLoading(false);
    }
  };return (
    <Box display="flex" minHeight="100vh" >
      <Box justifyContent="center" alignItems="center" bgcolor="#cbb4f7" flexDirection="column"  width={isMobile ? "0%" : "60%"} 
  display={isMobile ? "none" : "flex"} >
        <Avatar src={logo} alt="Logo de la empresa" sx={{ width: 300, height: 300, mb: 2, boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)' }}/>
        <Typography variant="h3">

          CRM - Centralización de Información de Llamadas
        </Typography>
      </Box>
      <Box  width="100%"  display="flex" justifyContent="center" alignItems="center" sx={{
        backgroundImage: 'linear-gradient(45deg, #5a97f7 30%, #FF8E53 90%)',
        boxShadow: 'inset 5px 0px 10px -5px rgba(0,0,0,0.5)'
        }}>
        <Card elevation={15} sx={{ width: '80%', bgcolor: '#FFFFFF', borderRadius: '15px', overflow: 'hidden' }}>
          <CardContent>
            <Box display="flex" flexDirection="column" alignItems="center" mb={3}>
              <Avatar src={logo} alt="Logo de la empresa" sx={{ width: 64, height: 64, mb: 2, boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)' }}/>
              <Typography variant="h5">Iniciar sesión</Typography>
            </Box>
            
            <form onSubmit={handleSubmit}>
            <Box mb={2}>
              <TextField
                label="Usuario"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                fullWidth
                required
                variant="outlined"
              />
            </Box>

            <Box mb={2}>
              <TextField
                label="Contraseña"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                fullWidth
                required
                variant="outlined"
                InputProps={{
                  endAdornment: (
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  )
                }}
              />
            </Box>

              <Button
                variant="contained"
                color="primary"
                type="submit"
                disabled={isLoading}
                fullWidth
                mb={2}
                sx={{ boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)', borderRadius: '10px' }}
              >
                {isLoading ? <CircularProgress size={24} /> : 'Iniciar sesión'}
              </Button>
              <Button color="secondary" onClick={() => { /* Implementa la navegación aquí */ }}>
                ¿Olvidaste tu contraseña?
              </Button>
            </form>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default Login;